export default "__VITE_ASSET__C09zCA$0__"